import PropTypes from 'prop-types'

export const WizardTitle = ({ description, icon, title, titleAddon }) => (
  <div className="mt-4 mb-6">
    <div className="flex items-center gap-3">
      {icon && (
        <div className="p-2 text-white bg-indigo-800 rounded-full dark:bg-content2 h-14 w-14">
          {icon}
        </div>
      )}
      
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold">{title}</h1>
          {titleAddon && <div>{titleAddon}</div>}
        </div>

        <p className="text-content2-foreground">{description}</p>
      </div>
    </div>
  </div>
)

WizardTitle.propTypes = {
  description: PropTypes.string.isRequired,
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  titleAddon: PropTypes.node,
}